import {useDispatch} from 'react-redux'
import {
	markSessionComplete,
	markSessionIncomplete,
	addSessions,
	removeSession,
	setClientSessionsModal
} from './sessionsSlice'
import Incrementer from '../../Incrementer/Incrementer'
import LocaleDate from '../../LocaleDate/LocaleDate'

const ClientSessionsRow = ({data,showName=true})=>{
	const dispatch = useDispatch()

	const incrementCompleted = ()=>{
		//get an incomplete session
		const oldest = [...data.sessions].sort((a,b)=>a.is_completed-b.is_completed)[0]
		dispatch(markSessionComplete(oldest))
	}

	const decrementCompleted = ()=>{
		//get a complete session
		const completed = [...data.sessions].sort((a,b)=>a.is_completed-b.is_completed).pop()
		dispatch(markSessionIncomplete(completed))
	}

	const incrementTotal = ()=>{
		dispatch(addSessions({
			client_id:data.client.id,
			num_sessions:1
		}))
	}

	const decrementTotal = ()=>{
		//get an incomplete session if possible else remove any session
		const oldest = [...data.sessions].sort((a,b)=>a.is_completed-b.is_completed)[0]
		dispatch(removeSession(oldest))
	}

	const handleNameClick = ()=>{
		dispatch(setClientSessionsModal({
			show:true,
			client_id:data.client.id
		}))
	}

	const completed = data?.sessions?.reduce((t,s)=>t+s.is_completed,0)
	const total = data?.sessions?.length

	return (
		<div className="px-1 mt-1 pb-1 d-flex align-items-center" style={{borderBottom:'1px solid #ddd'}}>
			<div>
				<div>
					<strong onClick={handleNameClick} className="text-primary" style={{cursor:'pointer'}}>
						{showName?data.client.name:'More Info'}
					</strong>
				</div>
				{data.sessions.length>0&&
					<small>
						Most recent purchase: 
						<span className="text-info ml-1">
							<LocaleDate 
								date={new Date(data.sessions[0].date_purchased.split(' ').join('T'))}
								includeTime={false}
							/>
						</span>
					</small>
				}
			</div>
			<div className="ml-auto d-flex align-items-center">
				<Incrementer 
					onAdd={incrementCompleted}
					disableAdd={completed===total}
					disableSubtract={completed===0}
					onSubtract={decrementCompleted}
					value={completed}
				/>
				<span>/</span>
				<Incrementer 
					onAdd={incrementTotal}
					disableSubtract={total===completed}
					onSubtract={decrementTotal}
					value={data.total}
				/>
			</div>
		</div>
	)
}

export default ClientSessionsRow